module.exports = __webpack_public_path__ + "img/bubble.9e4d303e.jpg";